import React, { useRef, useState } from 'react';
import './Contact.css';
import emailjs from 'emailjs-com';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
        const form = useRef();

        const sendEmail = (e) => {

                e.preventDefault();

                emailjs.sendForm('service_e4c1zhl', 'template_jxgmrwn', form.current, 'user_MeQwYwx1k7QNxJQZO9C6p')
                        .then((result) => {
                                // alert("Thank You! Successfully Send Email. Abdullah Al Akash will reply very soon.")
                                if (result) {
                                        toast.success(`Thank You! Successfully Received Your Email. Abdullah Al Akash will reply very soon.`)
                                }
                                e.target.reset();
                        }, (error) => {
                                // console.log(error.text);
                        });
        };
        return (
                <div className="contact-section">
                        <ToastContainer></ToastContainer>
                        <div className="container pt-5 pb-5">
                                <div className="row">
                                        <div className="col-lg-6 p-5"

                                        >
                                                <form ref={form} onSubmit={sendEmail}
                                                        data-aos="zoom-out"
                                                        data-aos-duration="3000">
                                                        <h2 className="text-center fw-bold brand-color text-decoration-underline pb-3 pt-3">Contact With Me</h2>
                                                        <div className="mb-3">
                                                                <label htmlFor="name" className="form-label text-white">Your Name</label>
                                                                <input type="text" className="form-control" name="user_name" required />
                                                        </div>
                                                        <div className="mb-3">
                                                                <label htmlFor="email" className="form-label text-white">Your Email</label>
                                                                <input type="email" className="form-control" name="user_email" required />
                                                        </div>
                                                        <div className="mb-3">
                                                                <label htmlFor="email" className="form-label text-white">Your Message</label>
                                                                <textarea className="form-control" style={{ height: "150px" }} name="message" required></textarea>
                                                        </div>
                                                        <div className="d-grid gap-2">
                                                                <button type="submit" className="btn brand-btn fs-4 fw-bold">Submit Message</button>
                                                        </div>
                                                        <div className="mb-3 mt-2">
                                                                <h6 className="fst-italic text-white text-end">Sending to <span className="brand-color fw-bold">aabdullahalakash@gmail.com</span></h6>
                                                        </div>

                                                </form>
                                        </div>
                                        <div className="col-lg-6 p-5 d-flex justify-content-center"
                                                data-aos="zoom-in-up"
                                                data-aos-duration="3000"
                                        >
                                                <img src="https://user-images.githubusercontent.com/37551474/113611467-3a567d80-9657-11eb-862b-b07b4f105c6f.gif" className="img-fluid rounded-2" alt="" />

                                        </div>
                                </div>

                        </div>
                </div>

        );
};

export default Contact;